import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "Dashboard": "Dashboard",
      "Welcome back! Here's your usage summary.": "Welcome back! Here's your usage summary.",
      "API Keys": "API Keys",
      "Manage your API keys for integrations": "Manage your API keys for integrations",
      "Logs": "Logs",
      "Billing": "Billing",
      "Profile": "Profile",
      "Profile Settings": "Profile Settings",
      "Sign Out": "Sign Out",
      "Create New Key": "Create New Key",
      "Total Requests": "Total Requests",
      "Success Rate": "Success Rate",
      "Usage This Month": "Usage This Month",
      "API Keys Count": "API Keys",
      "Toggle language": "Toggle language",
      "Loading dashboard...": "Loading dashboard...",
      "this month": "this month",
      "Excellent": "Excellent",
      "excellentPerformance": "Excellent Performance",
      "remaining": "remaining",
      "Limit reached": "Limit reached",
      "Active keys": "Active keys",
      "usageTrend": "Usage Trend",
      "last7Days": "Last 7 Days",
      "last30Days": "Last 30 Days",
      "sevenDays": "7 Days",
      "thirtyDays": "30 Days",
      "Usage Trend (Last 7 Days)": "Usage Trend (Last 7 Days)",
      "View Details": "View Details",
      "Quick Actions": "Quick Actions",
      "Manage API Keys": "Manage API Keys",
      "View Logs": "View Logs",
      "Edit Profile": "Edit Profile",
      "Upgrade Plan": "Upgrade Plan",
      "Are you sure you want to revoke this API key?": "Are you sure you want to revoke this API key?",
      "Create New API Key": "Create New API Key",
      "Key name (e.g., Production, Testing)": "Key name (e.g., Production, Testing)",
      "Cancel": "Cancel",
      "Create Key": "Create Key",
      "Your New API Key": "Your New API Key",
      "Copy Key": "Copy Key",
      "Save this key securely. You won't see it again!": "Save this key securely. You won't see it again!",
      "Close": "Close",
      "Loading API keys...": "Loading API keys...",
      "No API keys yet. Create one to get started!": "No API keys yet. Create one to get started!",
      "No API Keys Yet": "No API Keys Yet",
      "Create one to get started!": "Create one to get started!",
      "Create Your First Key": "Create Your First Key",
      "Done": "Done",
      "No description": "No description",
      "Name": "Name",
      "Key": "Key",
      "Status": "Status",
      "Created": "Created",
      "Last Used": "Last Used",
      "Actions": "Actions",
      "Hide": "Hide",
      "Show": "Show",
      "Copy not available": "Copy not available",
      "Copy only available when key is created": "Copy only available when key is created",
      "Active": "Active",
      "Revoked": "Revoked",
      "Never": "Never",
      "Revoke API Key": "Revoke API Key",
      "API Logs": "API Logs",
      "View all OTP requests and delivery status": "View all OTP requests and delivery status",
      "Export CSV": "Export CSV",
      "All Status": "All Status",
      "Delivered": "Delivered",
      "Failed": "Failed",
      "Loading logs...": "Loading logs...",
      "No logs found. Start sending OTPs to see them here.": "No logs found. Start sending OTPs to see them here.",
      "Phone": "Phone",
      "OTP Code": "OTP Code",
      "Message ID": "Message ID",
      "Created At": "Created At",
      "Admin Panel": "Admin Panel",
      "Admin Dashboard": "Admin Dashboard",
      "Users Management": "Users Management",
      "Plans Management": "Plans Management",
      "System Statistics": "System Statistics",
      "Total Users": "Total Users",
      "Total Plans": "Total Plans",
      "Total API Keys": "Total API Keys",
      "Total OTP Requests": "Total OTP Requests",
      "Successful Deliveries": "Successful Deliveries",
      "Failed Deliveries": "Failed Deliveries",
      "System Information": "System Information",
      "Manage Users": "Manage Users",
      "Manage Plans": "Manage Plans",
      "View Statistics": "View Statistics",
      "Add User": "Add User",
      "Edit User": "Edit User",
      "Delete User": "Delete User",
      "Add Plan": "Add Plan",
      "Edit Plan": "Edit Plan",
      "Delete Plan": "Delete Plan",
      "First Name": "First Name",
      "Last Name": "Last Name",
      "Email": "Email",
      "Role": "Role",
      "Search users...": "Search users...",
      "User not found": "User not found",
      "Plan Name": "Plan Name",
      "Description": "Description",
      "Price (USD)": "Price (USD)",
      "OTP Limit/Month": "OTP Limit/Month",
      "API Keys Limit": "API Keys Limit",
      "Support Level": "Support Level",
      "Search plans...": "Search plans...",
      "Plan not found": "Plan not found",
      "Basic": "Basic",
      "Standard": "Standard",
      "Premium": "Premium",
      "Email Support": "Email Support",
      "Priority Support": "Priority Support",
      "Are you sure you want to delete this user?": "Are you sure you want to delete this user?",
      "Are you sure you want to delete this plan?": "Are you sure you want to delete this plan?",
      "Loading users...": "Loading users...",
      "Loading plans...": "Loading plans...",
      "No users found": "No users found",
      "No plans found": "No plans found",
      "User": "User",
      "Admin": "Admin",
      "Save": "Save",
      "Edit": "Edit",
      "Delete": "Delete",
      "Manage all system users and their roles": "Manage all system users and their roles",
      "Users": "Users",
      "Plans": "Plans",
      "System Stats": "System Stats",
      "Manage system users and roles": "Manage system users and roles",
      "Manage billing plans": "Manage billing plans",
      "View system statistics": "View system statistics",
      "Welcome to the admin panel. Manage your system here.": "Welcome to the admin panel. Manage your system here.",
      "Manage billing plans and features": "Manage billing plans and features",
      "Link Phone Numbers": "Link Phone Numbers",
      "Connect your WhatsApp phone numbers to send OTP messages": "Connect your WhatsApp phone numbers to send OTP messages",
      "Link New Phone": "Link New Phone",
      "Generating...": "Generating...",
      "Your Plan Limit": "Your Plan Limit",
      "Verified": "Verified",
      "Disconnected": "Disconnected",
      "Paused": "Paused",
      "Type:": "Type:",
      "Endpoint:": "Endpoint:",
      "Keep secure. Never share publicly.": "Keep secure. Never share publicly.",
      "Quick Start": "Quick Start",
      "Test your integration with this command:": "Test your integration with this command:",
      "Copy Command": "Copy Command",
      "Paste in terminal or use in application code": "Paste in terminal or use in application code",
      "Link New WhatsApp Phone": "Link New WhatsApp Phone",
      "Loading...": "Loading...",
      "Rescan QR Code": "Rescan QR Code",
      "Scanning...": "Scanning...",
      "Rescan or change your phone connection": "Rescan or change your phone connection",
      "Pause Phone": "Pause Phone",
      "Temporarily disable this phone": "Temporarily disable this phone",
      "Resume Phone": "Resume Phone",
      "Reactivate this phone": "Reactivate this phone",
      "API Key": "API Key",
      "Copy API Key to clipboard": "Copy API Key to clipboard",
      "Failed to reconnect phone. Please try again.": "Failed to reconnect phone. Please try again.",
      "Link Your First Phone": "Link Your First Phone",
      "Billing & Plans": "Billing & Plans",
      "Choose the perfect plan for your needs": "Choose the perfect plan for your needs",
      "Current": "Current",
      "Popular": "Popular",
      "month": "month",
      "Free": "Free",
      "Loading billing information...": "Loading billing information...",
      "Manage your account information and security": "Manage your account information and security",
      "Saving...": "Saving...",
      "Save Changes": "Save Changes",
      "Current Plan": "Current Plan",
      "Monthly Price": "Monthly Price",
      "Features": "Features",
      "Password Change": "Password Change",
      "Change Password": "Change Password",
      "Old Password": "Old Password",
      "New Password": "New Password",
      "Confirm New Password": "Confirm New Password",
      "Danger Zone": "Danger Zone",
      "Logout": "Logout",
      "Are you sure you want to logout?": "Are you sure you want to logout?",
      "Try Sending OTP": "Try Sending OTP",
      "Test your WhatsApp integration with a real message": "Test your WhatsApp integration with a real message",
      "Paste your API key here": "Paste your API key here",
      "Get your API key from the dashboard": "Get your API key from the dashboard",
      "Phone Number": "Phone Number",
      "e.g. 4850": "e.g. 4850",
      "Message": "Message",
      "Your OTP is {otp}. Please enter it within 10 minutes.": "Your OTP is {otp}. Please enter it within 10 minutes.",
      "Use {otp} placeholder for the code": "Use {otp} placeholder for the code",
      "Error sending message": "Error sending message",
      "Send OTP": "Send OTP",
      "Sending...": "Sending...",
      "Message Sent": "Message Sent",
      "Tips": "Tips",
      "Email Address": "Email Address",
      "Email cannot be changed": "Email cannot be changed",
      "Company": "Company",
      "Your Company Name": "Your Company Name",
      "e.g. +962791234567": "e.g. +962791234567",
      "Profile Information": "Profile Information",
      "API Docs": "API Docs",
      "You can link up to {{max}} phone number(s)": "You can link up to {{max}} phone number(s)",
      "Currently linked: {{count}}/{{max}}": "Currently linked: {{count}}/{{max}}",
      "All time": "All time",
      "Go to Users": "Go to Users",
      "Go to Plans": "Go to Plans",
      "Go to Stats": "Go to Stats",
      "Needs attention": "Needs attention",
      "requests": "requests",
      "View All": "View All",
      "User created successfully": "User created successfully",
      "User updated successfully": "User updated successfully",
      "User deleted successfully": "User deleted successfully",
      "Update": "Update",
      "Create": "Create",
      "Balance": "Balance",
      "Available balance": "Available balance",
      "Add Balance to Users": "Add Balance to Users",
      "Manage user account balances and credits": "Manage user account balances and credits",
      "Add Balance": "Add Balance",
      "Select User": "Select User",
      "Choose a user": "Choose a user",
      "Amount (OTPs)": "Amount (OTPs)",
      "Enter OTP amount": "Enter OTP amount",
      "Custom Message (Optional)": "Custom Message (Optional)",
      "Enter a custom message...": "Enter a custom message...",
      "Clear": "Clear",
      "Please select a user and enter an amount": "Please select a user and enter an amount",
      "Balance added successfully": "Balance added successfully",
      "Failed to load users": "Failed to load users",
      "Failed to add balance": "Failed to add balance",
      "Confirm Balance Addition": "Confirm Balance Addition",
      "Processing...": "Processing...",
      "Confirm": "Confirm",
      "Create and manage subscription plans": "Create and manage subscription plans",
      "Plan deleted successfully": "Plan deleted successfully",
      "Failed to delete plan": "Failed to delete plan",
      "Plan name is required": "Plan name is required",
      "Plan updated successfully": "Plan updated successfully",
      "Plan created successfully": "Plan created successfully",
      "Failed to save plan": "Failed to save plan",
      "per month": "per month",
      "OTP Limit": "OTP Limit",
      "Phone Numbers": "Phone Numbers",
      "Add New Plan": "Add New Plan",
      "e.g. Starter, Professional, Enterprise": "e.g. Starter, Professional, Enterprise",
      "Describe this plan briefly": "Describe this plan briefly",
      "Slug (auto-generated)": "Slug (auto-generated)",
      "Leave empty to auto-generate from name": "Leave empty to auto-generate from name",
      "Used in URLs and identifiers": "Used in URLs and identifiers",
      "Update Plan": "Update Plan",
      "Create Plan": "Create Plan",
      "Create first plan": "Create first plan",
      "Failed to fetch plans": "Failed to fetch plans",
      "Welcome back": "Welcome back",
      "Monitor your API performance in real-time and optimize your integration": "Monitor your API performance in real-time and optimize your integration",
      "Monthly Usage": "Monthly Usage",
      "All Systems": "All Systems",
      "Operational": "Operational",
      "Performance Trend": "Performance Trend",
      "Premium Experience": "Premium Experience",
      "you@example.com": "you@example.com",
      "Password": "Password",
      "Remember me": "Remember me",
      "Forgot password?": "Forgot password?",
      "Sign in to access your dashboard": "Sign in to access your dashboard",
      "Don't have an account?": "Don't have an account?",
      "Create one": "Create one",
      "Secure OTP Delivery": "Secure OTP Delivery",
      "Trusted by businesses worldwide": "Trusted by businesses worldwide",
      "WhatsApp OTP": "WhatsApp OTP",
      "Instant delivery via WhatsApp": "Instant delivery via WhatsApp",
      "Lightning Fast": "Lightning Fast",
      "99.9% uptime guarantee": "99.9% uptime guarantee",
      "Enterprise Security": "Enterprise Security",
      "Bank-level encryption": "Bank-level encryption",
      "OTPs Sent": "OTPs Sent",
      "Customers": "Customers",
      "Signing In...": "Signing In..."
    }
  },
  ar: {
    translation: {
      "Dashboard": "لوحة التحكم",
      "Welcome back! Here's your usage summary.": "مرحبًا بعودتك! إليك ملخص استخدامك.",
      "API Keys": "مفاتيح API",
      "Manage your API keys for integrations": "قم بإدارة مفاتيح API الخاصة بك للتكاملات",
      "Logs": "السجلات",
      "Billing": "الفوترة",
      "Profile": "الملف الشخصي",
      "Profile Settings": "إعدادات الملف الشخصي",
      "Sign Out": "تسجيل الخروج",
      "Create New Key": "إنشاء مفتاح جديد",
      "Total Requests": "إجمالي الطلبات",
      "Success Rate": "معدل النجاح",
      "Usage This Month": "الاستخدام هذا الشهر",
      "API Keys Count": "مفاتيح API",
      "Toggle language": "تبديل اللغة",
      "Loading dashboard...": "جاري تحميل لوحة التحكم...",
      "this month": "هذا الشهر",
      "Excellent": "ممتاز",
      "excellentPerformance": "أداء ممتاز",
      "remaining": "متبقي",
      "Limit reached": "تم الوصول للحد",
      "Active keys": "مفاتيح نشطة",
      "usageTrend": "اتجاه الاستخدام",
      "last7Days": "آخر 7 أيام",
      "last30Days": "آخر 30 يوم",
      "sevenDays": "7 أيام",
      "thirtyDays": "30 يوم",
      "Usage Trend (Last 7 Days)": "اتجاه الاستخدام (آخر 7 أيام)",
      "View Details": "عرض التفاصيل",
      "Quick Actions": "إجراءات سريعة",
      "Manage API Keys": "إدارة مفاتيح API",
      "View Logs": "عرض السجلات",
      "Edit Profile": "تعديل الملف الشخصي",
      "Upgrade Plan": "ترقية الخطة",
      "Are you sure you want to revoke this API key?": "هل أنت متأكد أنك تريد إلغاء هذا المفتاح؟",
      "Create New API Key": "إنشاء مفتاح API جديد",
      "Key name (e.g., Production, Testing)": "اسم المفتاح (مثال: الإنتاج، الاختبار)",
      "Cancel": "إلغاء",
      "Create Key": "إنشاء المفتاح",
      "Your New API Key": "مفتاح API الجديد الخاص بك",
      "Copy Key": "نسخ المفتاح",
      "Save this key securely. You won't see it again!": "احفظ هذا المفتاح بأمان. لن تراه مرة أخرى!",
      "Close": "إغلاق",
      "Loading API keys...": "جاري تحميل مفاتيح API...",
      "No API keys yet. Create one to get started!": "لا توجد مفاتيح API بعد. أنشئ واحدًا للبدء!",
      "No API Keys Yet": "لا توجد مفاتيح API بعد",
      "Create one to get started!": "أنشئ واحدًا للبدء!",
      "Create Your First Key": "أنشئ أول مفتاح لك",
      "Done": "تم",
      "No description": "لا يوجد وصف",
      "Name": "الاسم",
      "Key": "المفتاح",
      "Status": "الحالة",
      "Created": "تاريخ الإنشاء",
      "Last Used": "آخر استخدام",
      "Actions": "الإجراءات",
      "Hide": "إخفاء",
      "Show": "إظهار",
      "Copy not available": "النسخ غير متاح",
      "Copy only available when key is created": "النسخ متاح فقط عند إنشاء المفتاح",
      "Active": "نشط",
      "Revoked": "ملغى",
      "Never": "أبدًا",
      "Revoke API Key": "إلغاء مفتاح API",
      "API Logs": "سجلات API",
      "View all OTP requests and delivery status": "عرض جميع طلبات OTP وحالة التسليم",
      "Export CSV": "تصدير CSV",
      "All Status": "كل الحالات",
      "Delivered": "تم التسليم",
      "Failed": "فشل",
      "Loading logs...": "جاري تحميل السجلات...",
      "No logs found. Start sending OTPs to see them here.": "لا توجد سجلات. ابدأ بإرسال OTPs لتظهر هنا.",
      "Phone": "رقم الجوال",
      "OTP Code": "رمز OTP",
      "Message ID": "معرّف الرسالة",
      "Created At": "تاريخ الإنشاء",
      "Admin Panel": "لوحة المسؤول",
      "Admin Dashboard": "لوحة التحكم للمسؤول",
      "Users Management": "إدارة المستخدمين",
      "Plans Management": "إدارة الخطط",
      "System Statistics": "إحصائيات النظام",
      "Total Users": "إجمالي المستخدمين",
      "Total Plans": "إجمالي الخطط",
      "Total API Keys": "إجمالي مفاتيح API",
      "Total OTP Requests": "إجمالي طلبات OTP",
      "Successful Deliveries": "التسليمات الناجحة",
      "Failed Deliveries": "التسليمات الفاشلة",
      "System Information": "معلومات النظام",
      "Manage Users": "إدارة المستخدمين",
      "Manage Plans": "إدارة الخطط",
      "View Statistics": "عرض الإحصائيات",
      "Add User": "إضافة مستخدم",
      "Edit User": "تحرير المستخدم",
      "Delete User": "حذف المستخدم",
      "Add Plan": "إضافة خطة",
      "Edit Plan": "تحرير الخطة",
      "Delete Plan": "حذف الخطة",
      "First Name": "الاسم الأول",
      "Last Name": "الاسم الأخير",
      "Email": "البريد الإلكتروني",
      "Role": "الدور",
      "Search users...": "ابحث عن المستخدمين...",
      "User not found": "المستخدم غير موجود",
      "Plan Name": "اسم الخطة",
      "Description": "الوصف",
      "Price (USD)": "السعر (دولار أمريكي)",
      "OTP Limit/Month": "حد OTP/الشهر",
      "API Keys Limit": "حد مفاتيح API",
      "Support Level": "مستوى الدعم",
      "Search plans...": "ابحث عن الخطط...",
      "Plan not found": "الخطة غير موجودة",
      "Basic": "أساسي",
      "Standard": "معياري",
      "Premium": "متميز",
      "Email Support": "دعم البريد الإلكتروني",
      "Priority Support": "دعم ذو أولوية",
      "Are you sure you want to delete this user?": "هل أنت متأكد أنك تريد حذف هذا المستخدم؟",
      "Are you sure you want to delete this plan?": "هل أنت متأكد أنك تريد حذف هذه الخطة؟",
      "Loading users...": "جاري تحميل المستخدمين...",
      "Loading plans...": "جاري تحميل الخطط...",
      "No users found": "لا توجد مستخدمون",
      "No plans found": "لم يتم العثور على خطط",
      "User": "مستخدم",
      "Admin": "مسؤول",
      "Save": "حفظ",
      "Edit": "تحرير",
      "Delete": "حذف",
      "Manage all system users and their roles": "إدارة جميع المستخدمين وأدوارهم",
      "Users": "المستخدمون",
      "Plans": "الخطط",
      "System Stats": "إحصائيات النظام",
      "Manage system users and roles": "إدارة مستخدمي النظام والأدوار",
      "Manage billing plans": "إدارة خطط الفوترة",
      "View system statistics": "عرض إحصائيات النظام",
      "Welcome to the admin panel. Manage your system here.": "مرحبًا بك في لوحة المسؤول. قم بإدارة نظامك هنا.",
      "Manage billing plans and features": "إدارة خطط الفوترة والميزات",
      "Link Phone Numbers": "ربط أرقام الهاتف",
      "Connect your WhatsApp phone numbers to send OTP messages": "ربط أرقام هاتفك على WhatsApp لإرسال رسائل OTP",
      "Link New Phone": "ربط هاتف جديد",
      "Generating...": "جاري الإنشاء...",
      "Your Plan Limit": "حد خطتك",
      "Verified": "موثق",
      "Disconnected": "غير متصل",
      "Paused": "معلق",
      "Type:": "النوع:",
      "Endpoint:": "نقطة النهاية:",
      "Keep secure. Never share publicly.": "أبقه آمناً. لا تشاركه علناً.",
      "Quick Start": "البدء السريع",
      "Test your integration with this command:": "اختبر تكاملك بهذا الأمر:",
      "Copy Command": "نسخ الأمر",
      "Paste in terminal or use in application code": "الصق في المحطة أو استخدمه في رمز التطبيق",
      "Link New WhatsApp Phone": "ربط هاتف WhatsApp جديد",
      "Loading...": "جاري التحميل...",
      "Rescan QR Code": "إعادة فحص رمز QR",
      "Scanning...": "جاري المسح...",
      "Rescan or change your phone connection": "أعد فحص أو غير اتصال هاتفك",
      "Pause Phone": "إيقاف الهاتف",
      "Temporarily disable this phone": "تعطيل هذا الهاتف مؤقتاً",
      "Resume Phone": "استئناف الهاتف",
      "Reactivate this phone": "إعادة تنشيط هذا الهاتف",
      "API Key": "مفتاح API",
      "Copy API Key to clipboard": "نسخ مفتاح API إلى الحافظة",
      "Failed to reconnect phone. Please try again.": "فشل إعادة الاتصال بالهاتف. يرجى المحاولة مرة أخرى.",
      "Link Your First Phone": "اربط هاتفك الأول",
      "Billing & Plans": "الفوترة والخطط",
      "Choose the perfect plan for your needs": "اختر الخطة المثالية لاحتياجاتك",
      "Current": "الحالي",
      "Popular": "الشهير",
      "month": "شهر",
      "Free": "مجاني",
      "Loading billing information...": "جاري تحميل معلومات الفوترة...",
      "Manage your account information and security": "قم بإدارة معلومات حسابك والأمان",
      "Saving...": "جاري الحفظ...",
      "Save Changes": "حفظ التغييرات",
      "Current Plan": "الخطة الحالية",
      "Monthly Price": "السعر الشهري",
      "Features": "الميزات",
      "Password Change": "تغيير كلمة المرور",
      "Change Password": "تغيير كلمة المرور",
      "Old Password": "كلمة المرور القديمة",
      "New Password": "كلمة المرور الجديدة",
      "Confirm New Password": "تأكيد كلمة المرور الجديدة",
      "Danger Zone": "منطقة الخطر",
      "Logout": "تسجيل الخروج",
      "Are you sure you want to logout?": "هل أنت متأكد أنك تريد تسجيل الخروج؟",
      "Try Sending OTP": "جرب إرسال OTP",
      "Test your WhatsApp integration with a real message": "اختبر تكاملك مع WhatsApp برسالة حقيقية",
      "Paste your API key here": "الصق مفتاح API الخاص بك هنا",
      "Get your API key from the dashboard": "احصل على مفتاح API الخاص بك من لوحة التحكم",
      "Phone Number": "رقم الهاتف",
      "e.g. 4850": "على سبيل المثال 4850",
      "Message": "الرسالة",
      "Your OTP is {otp}. Please enter it within 10 minutes.": "رمز OTP الخاص بك هو {otp}. يرجى إدخاله في غضون 10 دقائق.",
      "Use {otp} placeholder for the code": "استخدم عنصر نائب {otp} للرمز",
      "Error sending message": "خطأ في إرسال الرسالة",
      "Send OTP": "إرسال OTP",
      "Sending...": "جاري الإرسال...",
      "Message Sent": "تم إرسال الرسالة",
      "Tips": "نصائح",
      "Email Address": "عنوان البريد الإلكتروني",
      "Email cannot be changed": "لا يمكن تغيير البريد الإلكتروني",
      "Company": "الشركة",
      "Your Company Name": "اسم شركتك",
      "e.g. +962791234567": "مثال +962791234567",
      "Profile Information": "معلومات الملف الشخصي",
      "API Docs": "توثيق API",
      "You can link up to {{max}} phone number(s)": "يمكنك ربط حتى {{max}} رقم هاتف",
      "Currently linked: {{count}}/{{max}}": "المرتبط حالياً: {{count}}/{{max}}",
      "All time": "كل الوقت",
      "Go to Users": "انتقل إلى المستخدمين",
      "Go to Plans": "انتقل إلى الخطط",
      "Go to Stats": "انتقل إلى الإحصائيات",
      "Needs attention": "يحتاج اهتمام",
      "requests": "طلبات",
      "View All": "عرض الكل",
      "User created successfully": "تم إنشاء المستخدم بنجاح",
      "User updated successfully": "تم تحديث المستخدم بنجاح",
      "User deleted successfully": "تم حذف المستخدم بنجاح",
      "Update": "تحديث",
      "Create": "إنشاء",
      "Balance": "الرصيد",
      "Available balance": "الرصيد المتاح",
      "Add Balance to Users": "إضافة رصيد للمستخدمين",
      "Manage user account balances and credits": "إدارة أرصدة حسابات المستخدمين والأرصدة",
      "Add Balance": "إضافة رصيد",
      "Select User": "اختر مستخدم",
      "Choose a user": "اختر مستخدم",
      "Amount (USD)": "المبلغ (دولار)",
      "Enter amount": "أدخل المبلغ",
      "Custom Message (Optional)": "رسالة مخصصة (اختياري)",
      "Enter a custom message...": "أدخل رسالة مخصصة...",
      "Clear": "مسح",
      "Please select a user and enter an amount": "يرجى اختيار مستخدم وإدخال مبلغ",
      "Balance added successfully": "تمت إضافة الرصيد بنجاح",
      "Failed to load users": "فشل تحميل المستخدمين",
      "Failed to add balance": "فشل إضافة الرصيد",
      "Confirm Balance Addition": "تأكيد إضافة الرصيد",
      "Processing...": "جاري المعالجة...",
      "Confirm": "تأكيد",
      "Create and manage subscription plans": "إنشاء وإدارة خطط الاشتراك",
      "Plan deleted successfully": "تم حذف الخطة بنجاح",
      "Failed to delete plan": "فشل حذف الخطة",
      "Plan name is required": "اسم الخطة مطلوب",
      "Plan updated successfully": "تم تحديث الخطة بنجاح",
      "Plan created successfully": "تم إنشاء الخطة بنجاح",
      "Failed to save plan": "فشل حفظ الخطة",
      "per month": "في الشهر",
      "OTP Limit": "حد OTP",
      "Phone Numbers": "أرقام الهاتف",
      "Add New Plan": "إضافة خطة جديدة",
      "e.g. Starter, Professional, Enterprise": "مثال: Starter، Professional، Enterprise",
      "Describe this plan briefly": "اوصف هذه الخطة بإيجاز",
      "Slug (auto-generated)": "Slug (ينشأ تلقائيًا)",
      "Leave empty to auto-generate from name": "اتركها فارغة لإنشاء تلقائي من الاسم",
      "Used in URLs and identifiers": "مستخدم في عناوين URL والمعرفات",
      "Update Plan": "تحديث الخطة",
      "Create Plan": "إنشاء خطة",
      "Create first plan": "إنشاء أول خطة",
      "Failed to fetch plans": "فشل في جلب الخطط",
      "Welcome back": "مرحبًا بعودتك",
      "Monitor your API performance in real-time and optimize your integration": "راقب أداء API الخاص بك في الوقت الفعلي وحسّن التكامل الخاص بك",
      "Monthly Usage": "الاستخدام الشهري",
      "All Systems": "جميع الأنظمة",
      "Operational": "يعمل",
      "Performance Trend": "اتجاه الأداء",
      "Premium Experience": "تجربة متميزة",
      "you@example.com": "أنت@مثال.com",
      "Password": "كلمة المرور",
      "Remember me": "تذكرني",
      "Forgot password?": "هل نسيت كلمة المرور؟",
      "Sign in to access your dashboard": "قم بتسجيل الدخول للوصول إلى لوحة التحكم الخاصة بك",
      "Don't have an account?": "ليس لديك حساب؟",
      "Create one": "أنشئ واحدًا",
      "Secure OTP Delivery": "توصيل OTP الآمن",
      "Trusted by businesses worldwide": "موثوق به من قبل الشركات في جميع أنحاء العالم",
      "WhatsApp OTP": "WhatsApp OTP",
      "Instant delivery via WhatsApp": "التسليم الفوري عبر WhatsApp",
      "Lightning Fast": "سريع جداً",
      "99.9% uptime guarantee": "ضمان 99.9% من وقت التشغيل",
      "Enterprise Security": "أمان المؤسسة",
      "Bank-level encryption": "تشفير على مستوى البنك",
      "OTPs Sent": "OTPs المرسلة",
      "Customers": "العملاء",
      "Signing In...": "جاري تسجيل الدخول..."
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('locale') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
